import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useFetchURL from '../../components/Hooks/useFetchURL';
import OrderPage from './order-page';
import Swipeable from '../../Fronts/Main/Swipeable';
import { sto } from '../../Context/InshData';
import { uri } from '../../help/Api';
import LoadingPage from '../../services/LoadingPage';

export default function OrderContainer() {

    const parms ={
        safe: sto?.safe,
        branch: sto?.branchi,
        iempid: sto?.empi,
        user: sto?.idi
    }

  const locat = useLocation();
  const { data, fetching, fetchURL} = useFetchURL({ ...{ url: uri + `orders?id=${locat?.state?.id}`, dependencyArray: [] } });
    
    useEffect(()=>{
        console.log("loc al ", sto)
    })
  console.log("the localt", locat?.state)

  if(fetching || !data) return <LoadingPage />

  return (
    <>
    <OrderPage order={data} parms={parms} fetchURL={fetchURL}/>
  <Swipeable />
  </>
  );




};